import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {Load2}           from "@Common/react/load2";
import {IndependentList} from "@Common/react/shadow/independent-list";

export const loadTemplateOptionsList = ({allTemplateIds, selectedTemplateIds, next}) => cs(
    consumeContext("apis"),
    ["all", ({apis}, next) => IndependentList({
        list: allTemplateIds?.map((templateId) => ({
            key: templateId,
            render: (next) => cs(
                ["templateOptions", ({}, next) => Load2({
                    _key: templateId,
                    fetch: async () => {
                        if (!templateId) {
                            return null;
                        }
                        const sku = {
                            front: +templateId,
                            back : +templateId,
                        };
                        return !sku ? null : apis.next.getTemplateOptions(sku);
                    },
                    next,
                })],
                ({templateOptions}) => next(templateOptions),
            ),
        })),
        next,
    })],
    ({all}) => next({
        all: all?.map((r) => r.value),
        loading : selectedTemplateIds?.some((templateId) => all[allTemplateIds.indexOf(templateId)].loading),
        selected: selectedTemplateIds?.map ((templateId) => all[allTemplateIds.indexOf(templateId)].value),
    })
);

